import React from "react";
import close from "../../../../../../../assets/images/close-icon.svg";

import styles from "./SamplePitches.scss";

const SamplePitches = props => (
  <div className={styles.samplePitches}>
    <div className={styles.modalContainer}>
      <img
        src={close}
        className={styles.closebutton}
        onClick={() => props.onHide()}
      />
      <div className={styles.modalContent}>
        <div className={styles.header}>
          <h2 className={styles.title}>Sample Pitches</h2>
        </div>
        <div className={styles.divider}>
          <div className={styles.top} />
          <div className={styles.bottom} />
        </div>
        <div>
          <h3 className={styles.subTitle}>Sample One</h3>
        </div>
        <div className={styles.intro}>
          <p>
            I’m a seasoned strategic-branding and marketing professional with
            20+ years' experience developing brands and results-oriented
            marketing programs, with a specialty in the beauty, luxury, and
            lifestyle sectors. I have worked with several retailers on loyalty
            programs, with the objective being to build consumer engagement for
            both parties. Preparing competitive analyses that help drive
            targeted, actionable innovation is one of my specialties. Plus, I'm
            a [Company Name] customer! I believe I could complete this loyalty
            program analysis within two days for $1,500. Please note that I’m
            assuming I can find out how retailers handle internal logistics via
            secondary sources.
          </p>
        </div>
        <div>
          <h3 className={styles.subTitle}>Sample Two</h3>
        </div>
        <div className={styles.intro}>
          <p>
            I have extensive experience in customer acquisition and retention in
            the beauty, luxury, apparel, and consumer goods industry at such
            companies as Calvin Klein, L'Oreal, and Walmart.com. Additionally, I
            launched VeronicaBeard.com, where I helped increase sales from $500K
            to $5M in one year by leveraging marketing channels, growing the
            email list, and messaging customers at the right time. This past
            year, my team has grown the Calvin Klein.com business by
            double-digit comps, and its email program by more than 50%. I will
            be able to implement modeling and analytics, develop the growth
            strategy for all of your channels, and exceed in leveraging digital
            for sales growth.
          </p>
        </div>
        <div>
          <h3 className={styles.subTitle}>Sample Three</h3>
        </div>
        <div className={styles.intro}>
          <p>
            I am a financial-services professional with an MBA from Columbia and
            15+ years of experience at Morgan Stanley and Goldman Sachs as
            corporate controller and treasurer. Additionally, I consulted
            part-time as CFO for a mid-sized logistics company, which included
            tax mitigation for its entities, business line financial reporting,
            and profitability/cash flow analyses.
            <br />
            <br />I have extensive experience with management financials,
            financial forecasting/budgeting, and strategic planning from my
            years at MS and with New York start-up SavvyRoo.com.
            <br />
            <br />
            In addition, as head of Morgan Stanley NY Capital Management, I was
            responsible for ongoing communication with the SEC, rating agencies,
            and other regulatory bodies. I am very comfortable working with
            external constituents in an investor-relations and communications
            capacity.
            <br />
            <br />I feel confident that I can supply you with the CFO know-how
            and relevant analysis that you will need to help you in your
            financial decision-making.
          </p>
        </div>
        <div>
          <h3 className={styles.subTitle}>Sample Four</h3>
        </div>
        <div className={styles.intro}>
          <p>
            I come with a backing of 12 + years experience in product,
            marketing, and technology. I ran a financial services book of
            business for LinkedIn marketing solutions for roughly 5 years. I
            focused on guiding the marketer through each aspect of the marketing
            funnel while reaching their target audience at scale.
            <br />
            <br />
            My most recent technical product manager role at Priceline helped me
            define success from backend technologies through design UI to create
            amazing products for our users. I am no stranger to unknowns and
            tight deadlines.
            <br />
            <br />
            Your business sounds truly unique, and I'd love to learn it inside
            and out. I look forward to hearing more about your goals and how we
            can best reach them ASAP. My monthly rate is $6,500, and my timing
            is flexible. I am willing to get the job done for what your business
            requires.
          </p>
        </div>
      </div>
    </div>
  </div>
);

export default SamplePitches;



// WEBPACK FOOTER //
// ./src/routes/candidate/projects/matches/components/pitchItForm/samplePitches/SamplePitches.js